import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import Card from "../../Components/Card";
import Button from "../../Components/Button";
import "./Movies.css";

export const Movies = (props) => {
  // console.log(props.data);
  const [searchInput, setSearchInput] = useState({ title: "" });
  const [display, setDisplay] = useState(null);
  const [searchShow, setSearchShow] = useState(true);
  const [moviesCollection, setMoviesCollection] = useState([]);

  const handleSearch = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setSearchInput({
      ...searchInput,
      [e.target.name]: value,
    });
    // console.log(searchInput);
  };
  const handleSearchSubmit = (e) => {
    let result = props.data.find(
      (obj) => obj.Title.toUpperCase() === searchInput.title.toUpperCase()
    );
    let finalResult = result ? result : "No match found.";
    // console.log(finalResult);
    setDisplay(finalResult);
    setSearchShow(false);
  };
  const handleViewLibrary = () => {
    setSearchShow(true);
    setDisplay(null);
  };

  useEffect(() => {
    // console.log(props.data);
    setMoviesCollection(props.data);
  }, [props.data]);

  return (
    <div>
      <Header title="Your Movies" />
      <div className="search-section">
        {searchShow ? (
          <div>
            <div>
              <p>Search</p>
              <input
                name="title"
                value={searchInput.search}
                onChange={handleSearch}
                placeholder="Search your movies"
              />
            </div>
            <Button
              type="submit"
              text="Search"
              onClick={(e) => handleSearchSubmit(e)}
            />
          </div>
        ) : (
          <Button
            className="btn-view-lib"
            type="submit"
            text="View Library"
            onClick={(e) => handleViewLibrary(e)}
          />
        )}
      </div>
      <div className="cards-wrapper">
        {display === "No match found." ? (
          <p className="no-match">No match found.</p>
        ) : display ? (
          <Card data={display} />
        ) : (
          // {
          moviesCollection.length > 0 &&
          moviesCollection.map((item, index) => {
            return <Card data={item} key={index} />;
          })
        )}
      </div>
    </div>
  );
};

// export default Movies;
